import { BehaviorSubject } from 'rxjs';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { DwIamPermissionInfoService } from './iam-permission-info.service';
var DwIamActionAuthorizedService = /** @class */ (function () {
    function DwIamActionAuthorizedService(iamPermissionInfo) {
        this.iamPermissionInfo = iamPermissionInfo;
    }
    /**
     * 設定功能權限資料
     *
     * @param dwAuthorizedId 作業權限ID
     * @param dwActionId 功能按鈕ID
     */
    DwIamActionAuthorizedService.prototype.setActionAuth = function (dwAuthorizedId, dwActionId) {
        var _this = this;
        this.restriction = null;
        this.actionAuthorizedSubject = new BehaviorSubject(this.restriction);
        var authorizedList; // 作業與功能權限
        this.iamPermissionInfo.authorizedList$.pipe().subscribe(function (response) {
            authorizedList = response;
            var authorized = authorizedList[dwAuthorizedId];
            if (authorized) {
                var action = [];
                // 功能按鈕權限記錄在作業中，如果是子頁面就要以作業編號找功能權限
                if (authorized.programId === dwAuthorizedId) {
                    action = authorized.action;
                }
                else {
                    var programAuthorized = authorizedList[authorized.programId];
                    if (programAuthorized) {
                        action = programAuthorized.action;
                    }
                }
                action = action.filter(function (value) {
                    return value.id === dwActionId;
                });
                if (action.length === 1) {
                    if (action[0].hasOwnProperty('id') && action[0].hasOwnProperty('restriction')) {
                        _this.restriction = action[0].restriction;
                    }
                }
            }
            _this.actionAuthorizedSubject.next(_this.restriction);
        }, function (error) {
            authorizedList = {};
            console.log(dwAuthorizedId + '(' + dwActionId + '):');
            console.log(error);
        });
    };
    Object.defineProperty(DwIamActionAuthorizedService.prototype, "actionAuthorizedSubject$", {
        /**
         * 提供訂閱功能權限資料
         */
        get: function () {
            return this.actionAuthorizedSubject.asObservable().pipe(filter(function (obsData) { return obsData !== null; }), // 不廣播初始值
            distinctUntilChanged() // 有改變時才廣播
            );
        },
        enumerable: true,
        configurable: true
    });
    return DwIamActionAuthorizedService;
}());
export { DwIamActionAuthorizedService };
